import { ForwardedRef, forwardRef } from 'react';
import { AutoFocus } from '../../auto_focus';
import { NotificationAlert } from '../../notification_alert';
import { useFormContext } from './form.context';

export interface FormSuccessProps {}

export const CellulaFormSuccess = forwardRef<HTMLDivElement, FormSuccessProps>(function CellulaFormSuccess(
	_: FormSuccessProps,
	ref: ForwardedRef<HTMLDivElement>,
): JSX.Element | null {
	const formContext = useFormContext();

	if (formContext === undefined) {
		throw new Error('Form.Success must be used within an Form.Root to access FormContext');
	}

	if (!formContext.successMessage) {
		return null;
	}

	return (
		<NotificationAlert variant='success' ref={ref}>
			<AutoFocus>{formContext.successMessage}</AutoFocus>
		</NotificationAlert>
	);
});
